<template>
	<section class="content-width">
		<notice>
			This is a test notice. Use this if you want to draw attention, but subtly, to important information.
		</notice>
	</section>
</template>

<script>
import Notice from '@/components/Notice.vue';

export default {
	components: {
		Notice
	}
}
</script>

<style lang="scss">

</style>